/**
 * PDF Print Functionality
 * ----------------------------------------------------------------------------
 * This script adds functionality to print the current page as a PDF
 * when a button with the attribute `data-print-pdf` is clicked.
 * This is done by adding the class `print-pdf` to the body element.
 * 
 */

const printButton = document.querySelector( 'button[data-print-pdf]' );

if ( printButton ) {

  document.body.classList.add( 'print-pdf' );
  
  printButton.addEventListener( 'click' , ( e ) => {
    window.print();

  });
}